// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gWhd","fullView":"styles_fullView__3Bc8V"};